import React, { ChangeEvent } from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

import { useStyles } from './MuiCheckbox.styles';

type LabelPlacement = 'end' | 'start' | 'top' | 'bottom';
type CheckboxColor = 'primary' | 'secondary' | 'default';

export interface IMuiCheckboxProps {
	name: string;
	wrapperClass?: string;
	label?: string;
	value?: string;
	checked?: boolean;
	onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
	disabled?: boolean;
	labelPlacement?: LabelPlacement;
	color?: CheckboxColor;
}

export const MuiCheckbox = ({
	name,
	wrapperClass,
	label = '',
	value,
	checked,
	onChange,
	disabled,
	labelPlacement,
	color = 'primary',
}: IMuiCheckboxProps) => {
	const classes = useStyles();

	return (
		<FormControlLabel
			className={wrapperClass}
			label={label}
			labelPlacement={labelPlacement}
			control={
				<Checkbox
					className={classes.checkbox}
					name={name}
					value={value}
					checked={checked}
					disabled={disabled}
					onChange={onChange}
					color={color}
				/>
			}
		/>
	);
};
